module.exports = __webpack_public_path__ + "static/banner-mobile-08b13796681a64adeddf714c92927213.svg";